import React from 'react';
import { Button } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { COLOR_PRIMARY_1, COLOR_PRIMARY_2 } from 'src/utils/colors';

interface StrPropertiesCTAButtonProps {
  label: string;
  onClick: () => void;
  /** When true, button uses full width and is suitable for inline layout (e.g. overview section). Default false. */
  fullWidth?: boolean;
}

const StrPropertiesCTAButton: React.FC<StrPropertiesCTAButtonProps> = ({
  label,
  onClick,
  fullWidth = false,
}) => {
  return (
    <Button
      variant="text"
      endIcon={<ArrowForwardIcon />}
      onClick={onClick}
      sx={{
        backgroundColor: 'rgba(255, 255, 255, 0.95)',
        color: COLOR_PRIMARY_1,
        fontSize: '14px',
        fontWeight: 500,
        textTransform: 'none',
        padding: '8px 16px',
        borderRadius: '8px',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
        backdropFilter: 'blur(4px)',
        transition: 'all 0.2s ease',
        width: fullWidth ? '100%' : 'auto',
        justifyContent: fullWidth ? 'space-between' : 'flex-start',
        '&:hover': {
          backgroundColor: 'rgba(255, 255, 255, 1)',
          color: COLOR_PRIMARY_2,
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)',
          transform: 'translateY(-2px)',
        },
      }}
    >
      {label}
    </Button>
  );
};

export default StrPropertiesCTAButton;
